angular.module('siter.io').factory 'Intercom', ["$templateCache", "$http", "$timeout", "$translate", ($templateCache, $http, $timeout, $translate) ->
  intercom =
    init: (url) ->
      if !justclick.intercomFields
        return false
      if !justclick.intercomFields.helpChatIsGranted
        return false
      window.intercomSettings =
        app_id: justclick.intercomFields.app_id
        name: justclick.intercomFields.name
        email: justclick.intercomFields.email
        user_id: justclick.intercomFields.user_id
        author_id: justclick.intercomFields.author_id
        author_name: justclick.intercomFields.author_name
        author_email: justclick.intercomFields.author_email
        author_registration: justclick.intercomFields.author_registration
        tariff: justclick.intercomFields.tariff
        top: justclick.intercomFields.author_email
        hide_default_launcher: true
        custom_launcher_selector: '#custom-intercom-container'
        language_override: $translate.use()
      do ->
        w = window
        ic = w.Intercom

        l = ->
          s = d.createElement('script')
          s.type = 'text/javascript'
          s.async = true
          s.src = 'https://widget.intercom.io/widget/' + justclick.intercomFields.app_id
          x = d.getElementsByTagName('script')[0]
          x.parentNode.insertBefore s, x
          return

        if typeof ic == 'function'
          ic 'reattach_activator'
          ic 'update', intercomSettings
        else
          d = document

          i = ->
            i.c arguments
            return

          i.q = []

          i.c = (args) ->
            i.q.push args
            return

          w.Intercom = i
          if w.attachEvent
            w.attachEvent 'onload', l
          else
            w.addEventListener 'load', l, false
        return

      window.Intercom 'onShow', ->
        $timeout ->
          $(".intercom-gradient").hide()
          $(".intercom-messenger-frame").css({left: 20, right: "auto"})
        $(".intercom-launcher").addClass('intercom-launcher-active')

      window.Intercom 'onHide', ->
        $(".intercom-launcher").removeClass('intercom-launcher-active')

      return

  intercom
]





// WEBPACK FOOTER //
// ./src/app/common/services/intercom.service.coffee